import React, { useContext, useCallback } from 'react';
import { ModalWrapper } from 'components/ModalWindows/ModalWrapper';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import { ComboGroupContext, IComboGroupContext } from '../comboGroupState/comboGroupContext';

export const ModalWindows: React.FC = () => {
	const { changeTypeOfModalWindow, deleteSelectedItem, typeOfModalWindow } =
		useContext<IComboGroupContext>(ComboGroupContext);

	const handleChangeTypeOfModalWindow = useCallback(() => changeTypeOfModalWindow(null), [changeTypeOfModalWindow]);

	return (
		<ModalWrapper isVisible={!!typeOfModalWindow}>
			<ModalToConfirm
				onConsentEvent={deleteSelectedItem}
				onFailureEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'toConfirmDeleteItem'}
				description="deleteComboGroup"
				typeOfInfoIcon="toDelete"
			/>
			<ModalSentSuccessfully
				onConsentEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'success'}
				description="deleteComboGroupSuccessfully"
			/>
			<ModalSentError
				onConsentEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'error'}
				description="errorWhileDeletingComboGroup"
			/>
		</ModalWrapper>
	);
};
